import script from "./discountList.vue?vue&type=script&setup=true&lang=js"
export * from "./discountList.vue?vue&type=script&setup=true&lang=js"

import "./discountList.vue?vue&type=style&index=0&id=a14cb260&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a14cb260"]])

export default __exports__